<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'NewCard'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/box/NewCard.vue